import React from 'react';

const ROW = {present:0,point:0,wait:1,think:1,acknowledge:2,greet:2};

/** Original identity exports or browser-reviewed derivative poses; never a payment status. */
export default function Character({kind='tall', pose='original', label, className='', style}) {
  const dark = kind === 'dark';
  if (pose === 'original') return <img className={`qc-character ${className}`} src={`/qolak/character-${dark ? 'dark-hair' : 'tall'}-original.png`} alt={label || ''} style={style} draggable="false"/>;
  const row = ROW[pose] ?? 1;
  const x = dark ? 860 : 330;
  const width = dark ? 400 : 330;
  return <span className={`qc-character qc-character--pose ${className}`} role={label ? 'img' : undefined} aria-label={label} aria-hidden={label ? undefined : true} style={{display:'inline-block',aspectRatio:`${width}/341.333`,overflow:'hidden',position:'relative',...style}}>
    <img src="/qolak/character-poses-derived-v2.png" alt="" loading="lazy" draggable="false" style={{position:'absolute',width:`${1536 / width * 100}%`,maxWidth:'none',height:'auto',left:`${-x / width * 100}%`,top:`${-row * 100}%`,pointerEvents:'none'}}/>
  </span>;
}
